import React, { useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email");
      return;
    }
    try {
      await api.post("/newsletter", { email });
      setSent(true);
      setEmail("");
      toast.success("You're on the list.");
    } catch {
      toast.error("Something went wrong.");
    }
  };

  return (
    <footer id="footer" className="bg-aak-fg text-aak-bg pt-24 md:pt-32 pb-10 px-6 md:px-12 relative z-10">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-20 border-b border-aak-bg/15">
          <div className="lg:col-span-6">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
              className="font-serif font-light text-5xl md:text-7xl tracking-tighter leading-[0.95]"
            >
              Join the<br />
              <span className="italic text-aak-primary">inner circle.</span>
            </motion.h2>
            <p className="mt-6 text-sm text-aak-bg/60 max-w-sm leading-relaxed">
              Early access to new drops, atelier notes and private sales. No noise.
            </p>
          </div>

          <div className="lg:col-span-6 flex items-end">
            <form onSubmit={submit} className="w-full max-w-md" data-testid="newsletter-form">
              <label className="text-[10px] uppercase tracking-[0.25em] text-aak-bg/50">
                Email Address
              </label>
              <div className="flex items-center border-b border-aak-bg/30 mt-4 focus-within:border-aak-primary transition-colors">
                <input
                  data-testid="newsletter-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@studio.com"
                  className="flex-1 bg-transparent py-3 text-lg text-aak-bg placeholder:text-aak-bg/30 outline-none"
                />
                <button
                  data-testid="newsletter-submit"
                  type="submit"
                  className="p-2 text-aak-bg hover:text-aak-primary transition-colors"
                  aria-label="Subscribe"
                >
                  <ArrowRight className="w-6 h-6" strokeWidth={1.4} />
                </button>
              </div>
              {sent && <p className="mt-3 text-xs text-aak-primary">Welcome to AAK.</p>}
            </form>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <p className="font-serif text-6xl md:text-8xl tracking-tighter leading-none">
            AAK<span className="text-aak-primary">.</span>
          </p>
          <div className="flex gap-10 text-[11px] uppercase tracking-[0.2em] text-aak-bg/60">
            <a href="#" className="link-underline hover:text-aak-bg">Instagram</a>
            <a href="#" className="link-underline hover:text-aak-bg">Journal</a>
            <a href="#" className="link-underline hover:text-aak-bg">Stockists</a>
          </div>
        </div>
        <p className="mt-10 text-[11px] text-aak-bg/40">
          © {new Date().getFullYear()} House of AAK. Ethnic couture, warm earth.
        </p>
      </div>
    </footer>
  );
};
